export const version = 'v0.1.42 rc'
